import React, { useContext } from 'react';
import { Feedback, Button, Text } from 'react-onei';

import TagService from '../../../services/TagService';
import UserContext from '../../../context/UserContext';
import { events } from '../../../conf/tags_ga.conf';

function LetterConfirm() {
  const { wording, serviceConf } = useContext(UserContext);
  const { redirectUrl } = serviceConf;
  const { WBUTTON_003, WLOST_240, WLOST_241 } = wording;

  function handleClick() {
    TagService.sendEvent(events.endLetter);
    window.location.href = redirectUrl;
  };

  return (
    <Feedback id="confirm-letter" variant="success" title={WLOST_240} className="spacing-s no-spacing-mobile">
      <Text
        id="confirmation-letter-message"
        variant="lead"
      >
        {WLOST_241}
      </Text>
      <Button id="end-letter-button" onClick={handleClick}>
        {WBUTTON_003}
      </Button>
    </Feedback>
  );
}

export default LetterConfirm;